import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  lng: 'pl',
  fallbackLng: 'pl',
  supportedLngs: ['pl', 'en'],
});

export default i18n;
